"use cleint";

import api from "@/services/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

export function useRemoveOption() {
  const queryClient = useQueryClient();
  const abortController = useRef<AbortController | null>(null);

  const mutation = useMutation({
    mutationFn: async (id: string) => {
      abortController.current = new AbortController();

      const { data } = await api.delete(`/questions/options/${id}`);

      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/assessment-by-id"],
      });
    },
  });

  return { ...mutation, abort: () => abortController.current?.abort() };
}
